// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Iyzg","checkboxCol":"Table_checkboxCol__1AIwE","emailCol":"Table_emailCol__1BsIt","actionCol":"Table_actionCol__2dY_n"};